import { get } from '../../lib/axios'
import { useQuery } from '@tanstack/react-query'
import { SpringInfo } from './version'

const fetchSpringInfo = async () => {
  return get<SpringInfo>('/api/info')
}

export const getSpringInfo = () => {
  return useQuery({ queryKey: ['version'], queryFn: () => fetchSpringInfo(), retry: false })
}
